module.exports = __webpack_public_path__ + "static/thiem-profile-de6acca0e453da47e978f0d07e05430b.jpg";